
/**
 * Get CSS custom property value from document root
 * @param property - CSS custom property name (e.g., '--color-primary')
 * @returns Hex color value or fallback
 */
export const getCSSCustomProperty = (property: string): string => {
  if (typeof window !== 'undefined') {
    const value = getComputedStyle(document.documentElement).getPropertyValue(property).trim();
    return value || '#000000'; // fallback
  }
  return '#000000'; // fallback for SSR
};

/**
 * Convert hex color to rgba with alpha transparency
 * @param hex - Hex color string (with or without #)
 * @param alpha - Alpha value between 0 and 1
 * @returns RGBA color string
 */
export const hexToRgba = (hex: string, alpha: number): string => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (result) {
    const r = parseInt(result[1], 16);
    const g = parseInt(result[2], 16);
    const b = parseInt(result[3], 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
  return `rgba(0, 0, 0, ${alpha})`;
};

/**
 * Get responsive icon size based on device and className overrides
 * @param className - Optional className string to check for size overrides
 * @returns Icon size in pixels
 */
export const getResponsiveIconSize = (): number => 24;

/**
 * Get theme colors from CSS custom properties
 * @returns Object with commonly used theme colors
 */
export const getThemeColors = () => ({
  frenchBeige: getCSSCustomProperty('--color-french-beige'),
  sageGreen: getCSSCustomProperty('--color-sage-green'),
  maroon: getCSSCustomProperty('--color-maroon'),
  lightGrey: getCSSCustomProperty('--color-light-grey'),
  darkGrey: getCSSCustomProperty('--color-dark-grey'),
  black: getCSSCustomProperty('--color-black'),
  white: getCSSCustomProperty('--color-white'),
});
